var _rect, _circle, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 300,
    viewBox: "0 0 400 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 50,
    width: 300,
    height: 200,
    rx: 20,
    fill: "#E8F0FE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 120,
    r: 40,
    fill: "#1C4765"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200 170C167.9 170 142 195.9 142 228C142 230.2 142.1 232.4 142.4 234.5C159.4 246.8 180.9 254 200 254C219.1 254 240.6 246.8 257.6 234.5C257.9 232.4 258 230.2 258 228C258 195.9 232.1 170 200 170Z",
    fill: "#1C4765"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIllustration);
export default __webpack_public_path__ + "static/media/login-illustration.9d9c0bcf392d745d369b06925a43a073.svg";
export { ForwardRef as ReactComponent };